import classnames from "classnames";
import "./style.css";
import { DOTS, usePagination } from "./usePaginationHook";
const PaginationComponent: React.FC<{
  onPageChange: (pageNumber: number) => void;
  totalCount: number | 0;
  siblingCount?: number;
  currentPage: number;
  pageSize: number;
  className: string;
}> = ({ className, currentPage, onPageChange, pageSize, siblingCount = 1, totalCount }) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);  
  };

  const lastPage = paginationRange[paginationRange?.length - 1];
  return (
    <ul className={classnames("pagination-container", { [className]: className })}>
      <li
        className={classnames("pagination-item", {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <div className="left arrow" />
      </li>
      {paginationRange?.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return <li className="dots pagination-item">&#8230;</li>;
        }

        return (
          <li
            className={classnames("pagination-item", {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={classnames("pagination-item", {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <div className="right arrow" />
      </li>
    </ul>
  );
};

export default PaginationComponent;
